<template>
  <div id="quiz-privilege">
    <b-form @submit.prevent="submitForm">
      <b-card
        no-body
        class="p-2 container-card mb-1"
        :class="{ bypass: privilegeForm.isComplete }"
      >
        <b-col cols="12">
          <div class="permission-header">ผลลัพธ์สิทธิ์ใช้งาน</div>
          <div class="font-medium-3 text-black">
            <span class="mr-1 text-under text-black"
              >สมาชิกที่กำหนดเท่านั้น</span
            ><b>ที่ได้สิทธิ์ใช้งานเกมนี้ได้</b>
            <!-- <img
              src="~@/assets/images/icons/IconQuestion.png"
              alt=""
              class="ml-2"
              width="15"
            /> -->
          </div>
          <div class="custom-card-permis p-1 mt-2">
            <b-badge
              class="change-permission"
              v-for="(item, index) in changeOption.visibility"
              :key="index + 'item'"
              >{{ item.label }}</b-badge
            >

            <div
              class="text-change font-medium-3"
              @click="onOpenModalChangePermission"
            >
              change
            </div>
          </div>
        </b-col>
      </b-card>

      <b-card
        no-body
        class="p-2 container-card mb-1"
        :class="{ bypass: privilegeForm.isComplete }"
      >
        <b-col lg="8">
          <div class="mb-2 custom-ml">
            <span class="mb-1 text-black font-medium-3"
              >ประเภทการให้รางวัล</span
            >
            <b-row class="mt-2 ml-row">
              <b-col>
                <b-form-radio-group
                  v-model="privilegeForm.rewardType"
                  :options="changeOption.rewardTypeOption"
                  class="text-black custom-radio-group mr-4 font-medium-3"
                  value-field="item"
                  text-field="name"
                ></b-form-radio-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-card>
      <!-- Point -->
      <b-card
        :class="{ bypass: privilegeForm.isComplete }"
        no-body
        class="p-2 container-card mb-1"
        v-if="privilegeForm.rewardType == 2 || privilegeForm.rewardType == 1"
      >
        <b-col md="8">
          <div class="mb-2 custom-ml">
            <span class="mb-1 text-black font-medium-3"
              >กำหนดเงื่อนไขการให้แต้มของสมาชิก</span
            >
            <b-row class="mt-2 ml-row" id="condition-point ">
              <b-col md="6">
                <b-form-radio
                  name="condition-point"
                  v-model="privilegeForm.isEqual"
                  :value="true"
                  class="text-black custom-radio-group mr-3 font-medium-3"
                  >สมาชิกได้<span class="text-under-point">{{
                    privilegeForm.rewardType == 2
                      ? "แต้มเท่ากัน"
                      : "รางวัลเท่ากัน"
                  }}</span></b-form-radio
                >
              </b-col>

              <b-col md="6">
                <b-form-radio
                  name="condition-point"
                  v-model="privilegeForm.isEqual"
                  :value="false"
                  :disabled="changeOption.visibility.length == 0"
                  class="text-black custom-radio-group mr-3 font-medium-3"
                  >สมาชิกได้<span class="text-under-point">{{
                    privilegeForm.rewardType == 2
                      ? "แต้มไม่เท่ากัน"
                      : "รางวัลไม่เท่ากัน"
                  }}</span></b-form-radio
                >
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-card>

      <!-- กำหนดการให้แต้ม -->
      <b-card
        no-body
        class="p-2 container-card mb-1"
        v-if="
          (privilegeForm.isEqual == true && privilegeForm.rewardType == 2) ||
          (privilegeForm.isEqual == false && privilegeForm.rewardType == 2) ||
          (privilegeForm.isEqual == true && privilegeForm.rewardType == 1) ||
          (privilegeForm.isEqual == false && privilegeForm.rewardType == 1)
        "
      >
        <b-col>
          <div class="mb-2 custom-ml">
            <span class="mb-1 text-black font-medium-3">กำหนดการให้แต้ม</span>
            <!-- 1 -->
            <div class="d-flex align-items-center ml-row">
              <b-col cols="12" class="pl-0">
                <b-row class="pl-1 mt-1">
                  <b-form-checkbox
                    :disabled="privilegeForm.isComplete"
                    v-model="privilegeForm.answerSetPoint"
                    class="mr-0 custom-control-success"
                    name="is-rtl"
                    :value="1"
                    switch
                    inline
                  />
                  <b-col class="ml-2"
                    ><b-row class="text-black font-medium-3"
                      ><b
                        >ตอบถูกทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อรับแต้ม"
                            : "เพื่อรับของรางวัล"
                        }}</b
                      ></b-row
                    >

                    <b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                    >
                      <div
                        v-if="privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นจะต้องตอบคำถามให้ถูกทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้ม"
                            : "เพื่อได้รับของรางวัล"
                        }}
                      </div>
                      <div
                        v-else-if="!privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นจะต้องตอบคำถามให้ถูกทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้มตามระดับสมาชิก"
                            : "เพื่อได้รับของรางวัลตามระดับสมาชิก"
                        }}
                      </div>

                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 1 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 2
                        "
                      >
                        <input-spin-quiz
                          :isText="'แต้ม'"
                          :numValue="privilegeForm.point"
                          @update-number="updateNumPoint"
                          :isDisabled="privilegeForm.isComplete"
                          :isInputDisabled="false"
                        />
                      </div>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 1 &&
                          !privilegeForm.isEqual
                        "
                      >
                        <set-point-button
                          :customClass="'custom-btn-point'"
                          :isDisabled="privilegeForm.isComplete"
                          :btnLabel="
                            privilegeForm.rewardType == 2
                              ? dataTag.payload.length == 0
                                ? 'กำหนดแต้ม'
                                : 'แก้ไขแต้ม'
                              : dataTag.payload.length == 0
                              ? 'กำหนดของรางวัล'
                              : 'แก้ไขของรางวัล'
                          "
                          :setIcon="
                            privilegeForm.rewardType == 1 ? true : false
                          "
                          @click.native="
                            onOpenModalSetPoint(
                              privilegeForm.answerSetPoint,
                              dataTag.payload.length == 0
                            )
                          "
                        />
                      </div>
                    </b-row>

                    <b-row>
                      <!-- แต้ม -->
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 1 &&
                          !privilegeForm.isEqual &&
                          dataTag.payload.length != 0
                        "
                        class="card-set-point mt-2 p-1"
                        id="card-set-point"
                      >
                        <card-set-point-item-list
                          :dataArr="dataTag.payload"
                          :formData="privilegeForm"
                          :privilegeOption="
                            changeOption.privilegeInventoryOption
                          "
                        />
                      </div>
                      <!-- รางวัล -->
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 1 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 1
                        "
                        class="mt-1"
                        style="width: 100%"
                      >
                        <b-row>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                            >
                              <span class="required"> เลือกคลัง </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectInventory"
                              class="vselect-linehight redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectInventory
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="Master Inventory"
                              :reduce="(option) => option.value"
                              :options="changeOption.inventoryOption"
                              :clearable="false"
                              @input="
                                fetchPrivilegeInventory(
                                  privilegeForm.selectInventory,
                                  false
                                )
                              "
                            />
                          </b-col>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                            >
                              <span class="required"> เลือกของรางวัล </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectReward"
                              class="vselect-linehight redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectReward
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="กรุณาเลือกของรางวัล"
                              :reduce="(option) => option.value"
                              :options="changeOption.privilegeInventoryOption"
                              :clearable="false"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <!-- 2 -->
            <div class="d-flex align-items-center ml-row">
              <b-col cols="12" class="pl-0">
                <b-row class="pl-1 mt-1">
                  <b-form-checkbox
                    :disabled="privilegeForm.isComplete"
                    v-model="privilegeForm.answerSetPoint"
                    class="mr-0 custom-control-success"
                    name="is-rtl"
                    :value="2"
                    switch
                    inline
                  />

                  <b-col class="ml-2"
                    ><b-row class="text-black font-medium-3"
                      ><b
                        >ตอบครบทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อรับแต้ม"
                            : "เพื่อรับของรางวัล"
                        }}</b
                      ></b-row
                    >
                    <b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                    >
                      <div
                        v-if="privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นต้องตอบคำถามให้ครบทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้ม"
                            : "เพื่อได้รับของรางวัล"
                        }}
                      </div>
                      <div
                        v-else-if="!privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นต้องตอบคำถามให้ครบทุกข้อ
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้มตามระดับสมาชิก"
                            : "เพื่อได้รับรางวัลตามระดับสมาชิก"
                        }}
                      </div>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 2 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 2
                        "
                      >
                        <input-spin-quiz
                          :isDisabled="privilegeForm.isComplete"
                          :isText="'แต้ม'"
                          :numValue="privilegeForm.point"
                          :isInputDisabled="false"
                          @update-number="updateNumPoint"
                        />
                      </div>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 2 &&
                          !privilegeForm.isEqual
                        "
                      >
                        <set-point-button
                          :isDisabled="privilegeForm.isComplete"
                          :customClass="'custom-btn-point'"
                          :btnLabel="
                            privilegeForm.rewardType == 2
                              ? dataTag.payload.length == 0
                                ? 'กำหนดแต้ม'
                                : 'แก้ไขแต้ม'
                              : dataTag.payload.length == 0
                              ? 'กำหนดของรางวัล'
                              : 'แก้ไขของรางวัล'
                          "
                          :setIcon="
                            privilegeForm.rewardType == 1 ? true : false
                          "
                          @click.native="
                            onOpenModalSetPoint(
                              privilegeForm.answerSetPoint,
                              dataTag.payload.length == 0
                            )
                          "
                        />
                      </div>
                    </b-row>
                    <b-row>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 2 &&
                          !privilegeForm.isEqual &&
                          dataTag.payload.length != 0
                        "
                        class="card-set-point mt-2 p-1"
                      >
                        <card-set-point-item-list
                          :dataArr="dataTag.payload"
                          :formData="privilegeForm"
                          :privilegeOption="
                            changeOption.privilegeInventoryOption
                          "
                        />
                      </div>

                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 2 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 1
                        "
                        class="mt-1"
                        style="width: 100%"
                      >
                        <b-row>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                            >
                              <span class="required"> เลือกคลัง </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectInventory"
                              class="redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectInventory
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="Master Inventory "
                              :reduce="(option) => option.value"
                              :options="changeOption.inventoryOption"
                              :clearable="false"
                              @input="
                                fetchPrivilegeInventory(
                                  privilegeForm.selectInventory,
                                  false
                                )
                              "
                            />
                          </b-col>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                              ><span class="required"> เลือกของรางวัล </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectReward"
                              class="redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectReward
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="กรุณาเลือกของรางวัล"
                              :reduce="(option) => option.value"
                              :options="changeOption.privilegeInventoryOption"
                              :clearable="false"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <!-- 3 -->
            <div class="d-flex align-items-center ml-row">
              <b-col cols="12" class="pl-0">
                <b-row class="pl-1 mt-1">
                  <b-form-checkbox
                    v-model="privilegeForm.answerSetPoint"
                    class="mr-0 custom-control-success"
                    name="is-rtl"
                    :value="3"
                    switch
                    inline
                    :disabled="privilegeForm.isComplete"
                  />

                  <b-col class="ml-2"
                    ><b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                      ><div><b>ตอบถูกอย่างน้อย</b></div>
                      <div
                        v-if="
                          (privilegeForm.answerSetPoint == 3 &&
                            privilegeForm.isEqual) ||
                          (!privilegeForm.isEqual &&
                            privilegeForm.answerSetPoint == 3)
                        "
                        class="custom-m"
                      >
                        <input-spin-quiz
                          :isDisabled="privilegeForm.isComplete"
                          :isText="'ข้อ'"
                          :numValue="privilegeForm.minimumCorrect"
                          :customClass="
                            privilegeForm.minimumCorrect >
                            privilegeForm.numberQuiz
                              ? 'border-red'
                              : ''
                          "
                          :isInputDisabled="false"
                          @update-number="updateMinimumCorrect"
                        />

                        <span
                          class="text-color-warn"
                          v-if="
                            privilegeForm.minimumCorrect >
                            privilegeForm.numberQuiz
                          "
                          >กรอกจำนวนข้อเกิน กรุณากรอกจำนวนข้ออีกครั้ง</span
                        >
                      </div>
                    </b-row>
                    <b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                    >
                      <div
                        v-if="privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นต้องตอบคำถามให้ถูกครบตามจำนวนข้อที่กำหนด
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้ม"
                            : "เพื่อได้รับของรางวัล"
                        }}
                      </div>
                      <div
                        v-else-if="!privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นต้องตอบคำถามให้ถูกครบตามจำนวนข้อที่กำหนด
                        {{
                          privilegeForm.rewardType == 2
                            ? "เพื่อได้รับแต้มตามระดับสมาชิก"
                            : "เพื่อได้รับของรางวัลตามระดับสมาชิก"
                        }}
                      </div>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 3 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 2
                        "
                        class=""
                      >
                        <input-spin-quiz
                          :isDisabled="privilegeForm.isComplete"
                          :isText="'แต้ม'"
                          :numValue="privilegeForm.point"
                          :isInputDisabled="false"
                          @update-number="updateNumPoint"
                        />
                      </div>

                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 3 &&
                          !privilegeForm.isEqual
                        "
                      >
                        <set-point-button
                          :customClass="'custom-btn-point'"
                          :isDisabled="privilegeForm.isComplete"
                          :btnLabel="
                            privilegeForm.rewardType == 2
                              ? dataTag.payload.length == 0
                                ? 'กำหนดแต้ม'
                                : 'แก้ไขแต้ม'
                              : dataTag.payload.length == 0
                              ? 'กำหนดของรางวัล'
                              : 'แก้ไขของรางวัล'
                          "
                          :setIcon="
                            privilegeForm.rewardType == 1 ? true : false
                          "
                          @click.native="
                            onOpenModalSetPoint(
                              privilegeForm.answerSetPoint,
                              dataTag.payload.length == 0
                            )
                          "
                        />
                      </div>
                    </b-row>
                    <b-row>
                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 3 &&
                          !privilegeForm.isEqual &&
                          dataTag.payload.length != 0
                        "
                        class="card-set-point mt-2 p-1"
                      >
                        <card-set-point-item-list
                          :dataArr="dataTag.payload"
                          :formData="privilegeForm"
                          :privilegeOption="
                            changeOption.privilegeInventoryOption
                          "
                        />
                      </div>

                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 3 &&
                          privilegeForm.isEqual &&
                          privilegeForm.rewardType == 1
                        "
                        class="mt-1"
                        style="width: 100%"
                      >
                        <b-row>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                            >
                              <span class="required"> เลือกคลัง </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectInventory"
                              class="redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectInventory
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="Master Inventory "
                              :reduce="(option) => option.value"
                              :options="changeOption.inventoryOption"
                              :clearable="false"
                              @input="
                                fetchPrivilegeInventory(
                                  privilegeForm.selectInventory,
                                  false
                                )
                              "
                            />
                          </b-col>
                          <b-col>
                            <label
                              for="select-inventory"
                              class="font-medium-3 text-black"
                            >
                              <span class="required"> เลือกของรางวัล </span>
                            </label>
                            <v-select
                              :disabled="privilegeForm.isComplete"
                              v-model="privilegeForm.selectReward"
                              class="redeem-limit-container bg-dropdown"
                              :class="
                                privilegeForm.selectReward
                                  ? 'redeem-limit-selected'
                                  : null
                              "
                              placeholder="กรุณาเลือกของรางวัล"
                              :reduce="(option) => option.value"
                              :options="changeOption.privilegeInventoryOption"
                              :clearable="false"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <!-- 4 -->
            <div
              class="d-flex align-items-center ml-row"
              v-if="privilegeForm.rewardType == 2"
            >
              <b-col cols="12" class="pl-0">
                <b-row class="pl-1 mt-1">
                  <b-form-checkbox
                    v-model="privilegeForm.answerSetPoint"
                    class="mr-0 custom-control-success"
                    name="is-rtl"
                    :value="4"
                    switch
                    inline
                    :disabled="
                      privilegeForm.isComplete ||
                      changeOption.visibility.length == 0
                    "
                  />

                  <b-col class="ml-2"
                    ><b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                      ><b>ตอบข้อที่ถูกต้องเท่านั้น </b>
                    </b-row>
                    <b-row
                      class="text-black font-medium-3 d-flex justify-content-between"
                    >
                      <div
                        v-if="privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นจะได้รับแต้ม ต้องตอบคำถามข้อนั้น
                        ให้ถูกต้องเท่านั้น
                      </div>
                      <div
                        v-else-if="!privilegeForm.isEqual"
                        class="d-flex align-item-center"
                      >
                        ผู้เล่นจะได้รับแต้มตามระดับสมาชิก และต้องตอบคำถามข้อนั้น
                        ให้ถูกต้องเท่านั้น
                      </div>
                      <div
                        v-if="
                          (privilegeForm.answerSetPoint == 4 &&
                            privilegeForm.isEqual) ||
                          (privilegeForm.answerSetPoint == 4 &&
                            !privilegeForm.isEqual)
                        "
                        class=""
                      >
                        <set-point-button
                          :isDisabled="privilegeForm.isComplete"
                          :customClass="'custom-btn-point'"
                          :btnLabel="
                            dataTag.payload.length == 0
                              ? 'กำหนดแต้ม'
                              : 'แก้ไขแต้ม'
                          "
                          @click.native="
                            onOpenModalSetPoint(
                              privilegeForm.answerSetPoint,
                              dataTag.payload.length == 0
                            )
                          "
                        />
                      </div>
                    </b-row>

                    <b-row>
                      <div
                        v-if="
                          ((privilegeForm.answerSetPoint == 4 &&
                            privilegeForm.isEqual) ||
                            (privilegeForm.answerSetPoint == 4 &&
                              !privilegeForm.isEqual)) &&
                          dataTag.payload.length != 0 &&
                          privilegeForm.rewardType == 2
                        "
                        class="card-set-point mt-2 p-1"
                      >
                        <card-set-point-item-table
                          :dataArr="dataTag.payload"
                          :dataForm="privilegeForm"
                        />
                      </div>

                      <div
                        v-if="
                          privilegeForm.answerSetPoint == 4 &&
                          !privilegeForm.isEqual &&
                          dataTag.payload.length != 0 &&
                          privilegeForm.rewardType == 1
                        "
                        class="card-set-point mt-2 p-1"
                      >
                        <card-set-point-item-list
                          :dataArr="dataTag.payload"
                          :formData="privilegeForm"
                          :privilegeOption="
                            changeOption.privilegeInventoryOption
                          "
                        />
                      </div>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </div>
          </div>
        </b-col>
      </b-card>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center flex-wrap mt-3">
          <cancel-button
            :btn-label="'Back'"
            @click.native="$emit('onPreviousStep')"
            class="mr-2"
            stageBack
          />
          <save-button
            v-if="privilegeForm.isComplete == false"
            :type="'submit'"
            :btn-label="'Save'"
            :disabled="validatePrivilege"
          />
          <save-button
            v-else
            @click.native="nextPage"
            :btn-label="'Next'"
            :disabled="validatePrivilege"
          />
        </b-col>
      </b-row>
    </b-form>
    <change-permission-modal
      v-if="modalType.changePermission"
      @onCloseModal="onCloseModalChangePermission"
      @onSubmitForm="onSubmitFormChangePermission"
      :tagOption="tagOption"
    />

    <setting-point-modal
      v-if="modalType.setPoint"
      :dataModal="dataModal"
      :optionsInventory="changeOption.inventoryOption"
      :optionsPrivilege="changeOption.privilegeInventoryOption"
      :permissionOption="changeOption.visibility"
      @onCloseModal="onCloseModalSetPoint"
      @onSubmitForm="onSubmitFormSetPoint"
      @updatePointModal="updatePointModal"
      @inputPrivilegeInventory="fetchPrivilegeInventory"
      @onChange="onChangeReward"
    />
  </div>
</template>

<script>
import usePrivilege from "../hooks/usePrivilege";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
import ChangePermissionModal from "./privilege/ChangePermissionModal.vue";
import SettingPointModal from "./privilege/SettingPointModal.vue";
import SetPointButton from "@/views/components/button/SetPointButton.vue";
import CardSetPointItemTable from "./privilege/CardSetPointItemTable.vue";
import CardSetPointItemList from "./privilege/CardSetPointItemList.vue";

export default {
  components: {
    InputSpinQuiz,
    ChangePermissionModal,
    SetPointButton,
    SettingPointModal,
    CardSetPointItemTable,
    CardSetPointItemList,
  },
  setup() {
    const {
      changeOption,
      privilegeForm,
      onOpenModalChangePermission,
      onCloseModalChangePermission,
      modalType,
      onOpenModalSetPoint,
      onCloseModalSetPoint,
      dataTag,
      dataModal,
      updateNumPoint,
      updateMinimumCorrect,
      onSubmitFormChangePermission,
      onSubmitFormSetPoint,
      tagOption,
      updatePointModal,
      submitForm,
      fetchPrivilegeInventory,
      onChangeReward,
      validatePrivilege,
      nextPage,
    } = usePrivilege();
    return {
      changeOption,
      privilegeForm,
      onOpenModalChangePermission,
      onCloseModalChangePermission,
      modalType,
      onOpenModalSetPoint,
      onCloseModalSetPoint,
      dataTag,
      dataModal,
      updateNumPoint,
      updateMinimumCorrect,
      onSubmitFormChangePermission,
      onSubmitFormSetPoint,
      tagOption,
      updatePointModal,
      submitForm,
      fetchPrivilegeInventory,
      onChangeReward,
      validatePrivilege,
      nextPage,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/privilege.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>

<style >
#squiz-privilege .vselect-linehight.vs--open .vs__dropdown-toggle {
  border: none;
  background: transparent;
  box-shadow: none;
}

#quiz-privilege .vselect-linehight.vs--single .vs__dropdown-toggle {
  padding: 0 6px;
  background: transparent;
  border: none;
}

#quiz-privilege .vs__search::placeholder {
  color: #728aac;
  font-size: 1.25rem;
}

#quiz-privilege .vs--disabled .vs__search,
.vs--disabled .vs__open-indicator {
  background-color: transparent !important;
}

#quiz-privilege
  .v-select.redeem-limit-container.bg-dropdown.vs--single.vs--searchable.vs--disabled.redeem-limit-selected {
  border: none !important;
}
#quiz-privilege .vs--disabled .vs__dropdown-toggle {
  background: #efefef !important;
}
</style>